const getHostname = (): string => window.location.hostname;

const getHost = (): string => window.location.host;

const getPathname = (): string => window.location.pathname;

const getHref = (): string => window.location.href;

const setHref = (url: string): void => {
  window.location.href = url;
};

const replaceHref = (url: string): void => {
  window.location.replace(url);
};

export { getHostname, getHost, getPathname, getHref, setHref, replaceHref };
